import { Match, User } from "@/models";
import { Module } from "vuex";
import { actions, mutations } from ".";
import MatchUtils from "./../../utils/match.utils";
import { RootState } from "./../index";

export interface MatchState {
  match?: Match;
}

const state: MatchState = {
  match: undefined
};

export const namespaceMatch = "match";

export interface RootState extends RootState {
  [namespaceMatch]: MatchState;
}

export const matchModule: Module<MatchState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters: {
    isUserHomeOwnerOrCaptain: state => (user: User) =>
      state.match ? [state.match.hometeam.captain_id, state.match.hometeam.owner_id].includes(user.id) : false,
    isUserAwayOwnerOrCaptain: state => (user: User) =>
      state.match ? [state.match.awayteam.captain_id, state.match.awayteam.owner_id].includes(user.id) : false,
    isUserMatchReferee: state => (user: User) =>
      state.match ? state.match.referees.findIndex(referee => referee.user_id === user.id) > -1 : false,
    isUserEventReferee: state => (user: User) =>
      state.match ? state.match.event_referees.findIndex(referee => referee.user_id === user.id) > -1 : false,
    isMatchFinished: state => state.match && MatchUtils.isMatchFinished(state.match)
  }
};

export * from "./match.actions";
export * from "./match.mutations";
